import Vue from 'vue'
import { updateLabels } from './labels'
import { parser } from 'ima-svg-renderer'
import { stringToDOMNode } from '@/services/dom'

const { getLabelsFromSVG, getArrowBox, getDimensionsFromSVG } = parser
const state = {
  isLoading: false,
  hasArrowBox: false,
  data: null,
  height: 0,
  width: 0
}

// Mutations
const fetchSVGRequest = 'fetchSVGRequest'

const fetchSVGResponse = 'fetchSVGResponse'
export const resetSVG = 'resetSVG'

const mutations = {
  [fetchSVGRequest] (state) {
    state.isLoading = true
  },
  [fetchSVGResponse] (
    state,
    { svg, hasArrowBox, hasSloganField, width, height }
  ) {
    state.isLoading = false
    state.data = svg
    state.hasArrowBox = hasArrowBox
    state.hasSloganField = hasSloganField
    state.width = width
    state.height = height
  },
  [resetSVG] (state) {
    state.data = null
  }
}

// Actions
export const fetchSVG = 'fetchSVG'
const actions = {
  [fetchSVG]: ({ commit }, { svgPath }) => {
    commit(fetchSVGRequest)
    return Vue.http
      .get(`${SERVER_URL}/svg/${svgPath}`, {
        responseType: 'text'
      })
      .then(({ data: svg }) => {
        const node = stringToDOMNode(svg)
        const labels = getLabelsFromSVG(node)
        const { width, height } = getDimensionsFromSVG(node)
        commit(fetchSVGResponse, {
          svg,
          hasArrowBox: !!getArrowBox(node),
          hasSloganField: labels.some(({ isSlogan }) => isSlogan),
          width,
          height
        })
        commit(updateLabels, labels)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/svg.js